import { code } from '../components/basic/code';

const port = '5000';

const host = code.isDevelopmentEnv() ? 'http://localhost:' + port : 'https://g2o.ir';

export const apiConfig = {
    host: host,
    localeUrl: host,
    baseUrl: host,
    accountUrl: host + '/authentication',
    productUrl: host + '/product',
    networkUrl: host + '/network',
    attachmentUrl: host + '/attachment',
    licenseCodeUrl: host + '/license-code',
};
